import React from "react";
import { Box, Flex } from "@100mslive/roomkit-react";
import { LiveStatus, StreamActions } from "@components/Header/StreamActions";
import { StreamingHeader } from "@components/Header/StreamingHeader";
import { SelectLanguage } from "@components/SelectLanguage";
import AvatarDropdown from "./AvatarDropdown";
import { ConferencingHeader } from "./ConferencingHeader";
import { ParticipantCount } from "./ParticipantList";
import { isStreamingKit } from "../../common/utils";

export const Header = () => {
  const streaming = isStreamingKit();
  const Chosen = streaming ? StreamingHeader : ConferencingHeader;
  return (
    <Flex
      align="center"
      css={{ height: "100%", px: "$6", justifyContent: "space-between" }}
    >
      <Box css={{ flex: "1 1 auto" }}>
        <Chosen />
      </Box>
      <Box css={{ ml: "$4", display: "flex", alignItems: "center", gap: "$7" }}>
        <LiveStatus />
        {!streaming && <StreamActions />}
        <ParticipantCount />
        <SelectLanguage />
        <AvatarDropdown />
      </Box>
    </Flex>
  );
};
